<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_AddRailwayStation')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <div class="app-main-content railwayStation">
      <div class="grid-view">
        <div class="main-content">
          <div class="operations">
            <el-form
              :inline="true"
              label-width="50px"
              label-position="left"
              @submit.native.prevent="filter.pageNum=1;toQuery()"
            >
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('common.btn.query')">
                  <el-input
                    v-model="filter.likeName"
                    no="likeName"
                    :placeholder="$t('common.tips.fuzzySearch')"
                    style="width:310px"
                  />
                </el-form-item>
                <el-button no="query" size="mini" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
              </div>
            </el-form>
          </div>
          <div class="section grid-wrapper">
            <!--          config-module="101601"-->
            <cargo-ag-grid
              :grid-params.sync="girdParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;min-height: 320px"
              :show-side-bar="false"
            />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button no="add" type="primary" @click="addHandler">{{ $t('common.btn.add') }}</el-button>
      <el-button no="cancel" @click="visible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as railwayStationApi from '@/api/basicData/railwayStation'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'SelectStationTemplateListDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('CargoMsg.Cargo_AlreadyAddedOrNot'),
          field: 'isExistPort',
          width: 200,
          cellRenderer: params => {
            const iconName = !params.value ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.value ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 100
        }, {
          headerName: this.$t('baseInfo.city.code'),
          field: 'code',
          width: 100
        }, {
          headerName: this.$t('baseInfo.city.chineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.city.englishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CountryRegion'),
          field: 'countryCode',
          width: 200,
          valueGetter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.data.countryCode, 'name')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Region'),
          field: 'region',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', params.value, 'name')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeCode'),
          field: 'interchangeCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsoCode'),
          field: 'isoCode',
          width: 200
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal && this.railwayStation) {
        Object.assign(this.form, this.railwayStation)
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    toQuery() {
      const self = this
      const loading = getLoading()
      railwayStationApi.loadTempalteRailwayStation(self.filter).then(res => {
        self.loadTempalteRailwayStationHandler(res)
      }).finally(() => loading.close())
    },
    loadTempalteRailwayStationHandler(resp) {
      const item = resp.data
      const portList = item.platform
      const currentList = item.current
      for (const c of portList) {
        c.isExistPort = false
      }
      for (const c1 of portList) {
        for (const c2 of currentList) {
          if (c1.code === c2.code) {
            c1.isExistPort = true
            break
          }
        }
      }
      this.rowData = portList
    },
    addHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Information.SiteNotSelected'))
        return
      }
      const saveList = []
      for (const p of rows) {
        if (p.isExistPort) {
          this.$message.warning(p.code + this.$t('Information.AlreadyAddedCannotAddRepeatedly'))
          return
        } else {
          const _railwayStation = {}
          _railwayStation.code = p.code
          _railwayStation.englishName = p.englishName
          _railwayStation.chineseName = p.chineseName
          _railwayStation.countryCode = p.countryCode
          _railwayStation.region = p.region
          saveList.push(_railwayStation)
        }
      }
      const loading = getLoading()
      railwayStationApi.batchSave(saveList).then(resp => {
        syncSpecificBasicData(basicCacheKeys.basic_data_RailwayStation)
        this.savePortsHandler(resp)
      }).finally(() => {
        loading.close()
        this.toQuery()
      })
    },
    savePortsHandler(resp) {
      // todo CacheManager.getInstance().loadCache(RailwayStation.CODE_NAME)
      this.$emit('addCallBack', resp.data)
      this.closeHandler()
      this.$message.success(this.$t('Information.AddedSuccessfully'))
    },
    closeHandler() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
